import type { User } from '@/chat/types/User';

export default class ChatSession {
    private static assistentIdKey = 'invesl-assistentId';

    private static chatIdKey = 'invesl-chatId';

    private static hubKey = 'invesl-hub';

    private static topicKey = 'invesl-topic';

    private static tokenKey = 'invesl-token';

    private static agreedToPrivacyTermsKey = 'invesl-agreedToPrivacyTerms';

    private constructor(
        public assistentId: string,
        public chatId: string,
        public hub: string,
        public topic: string,
        public token: string,
        public agreedToPrivacyTerms: boolean,
        public handoverAcceptedBy: User | null,
        public handoverExpiresAt: Date | null,
    ) {}

    static startSession(
        assistentId: string,
        chatId: string,
        hub: string,
        topic: string,
        token: string,
    ): ChatSession {
        const session = new ChatSession(
            assistentId,
            chatId,
            hub,
            topic,
            token,
            false,
            null,
            null,
        );

        window.sessionStorage.setItem(ChatSession.assistentIdKey, assistentId);
        window.sessionStorage.setItem(ChatSession.chatIdKey, chatId);
        window.sessionStorage.setItem(ChatSession.hubKey, hub);
        window.sessionStorage.setItem(ChatSession.topicKey, topic);
        window.sessionStorage.setItem(ChatSession.tokenKey, token);
        window.sessionStorage.setItem(ChatSession.agreedToPrivacyTermsKey, 'false');

        return session;
    }

    static fromSession(): null | ChatSession {
        const assistentId = window.sessionStorage.getItem(ChatSession.assistentIdKey);
        const chatId = window.sessionStorage.getItem(ChatSession.chatIdKey);
        const hub = window.sessionStorage.getItem(ChatSession.hubKey);
        const topic = window.sessionStorage.getItem(ChatSession.topicKey);
        const token = window.sessionStorage.getItem(ChatSession.tokenKey);
        const agreedToPrivacyTerms = window.sessionStorage.getItem(ChatSession.agreedToPrivacyTermsKey);

        if (assistentId && chatId && hub && topic && token) {
            return new ChatSession(
                assistentId,
                chatId,
                hub,
                topic,
                token,
                agreedToPrivacyTerms === 'true',
                null,
                null,
            );
        }

        return null;
    }

    agreeToPrivacyTerms() {
        window.sessionStorage.setItem(ChatSession.agreedToPrivacyTermsKey, 'true');
        this.agreedToPrivacyTerms = true;
    }

    changeToken(
        hub: string,
        topic: string,
        token: string,
    ) {
        this.hub = hub;
        window.sessionStorage.setItem(ChatSession.hubKey, hub);
        this.topic = topic;
        window.sessionStorage.setItem(ChatSession.topicKey, topic);
        this.token = token;
        window.sessionStorage.setItem(ChatSession.tokenKey, token);
    }

    get topicUrl(): string {
        const url = new URL(this.hub);
        url.searchParams.append('topic', this.topic);
        return url.toString();
    }
}
